import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const numericalLozenge = css`
  --numericalLozengeSize: var(${themeVariables.typography.body.sizes.sm.lineHeight});

  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* A single digit is a circle; longer values like 9+ stretch into a lozenge. */
  min-width: var(--numericalLozengeSize);
  height: var(--numericalLozengeSize);
  padding: 0 var(${themeVariables.spacing.xxs});
  border-radius: 100px;
  background-color: var(--numericalLozengeBackground, var(${themeVariables.colors.page.default}));
  color: var(${themeVariables.colors.surface.interactive});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: 0.75rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1;

  &[data-inverted='true'] {
    background-color: var(
      --numericalLozengeBackground,
      var(${themeVariables.colors.surface.interactive})
    );
    color: var(${themeVariables.colors.page.default});
  }
`;
